import { render } from "./PageFormInformasiOrangTuaTiri.vue?vue&type=template&id=62c63647"
import script from "./PageFormInformasiOrangTuaTiri.vue?vue&type=script&lang=js"
export * from "./PageFormInformasiOrangTuaTiri.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__